import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Admin from "./Admin";
import "./App.css";
import DateItemList from "./components/DateItemList";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Page from "./components/Page";
import {
  CmsEvent,
  CmsImage,
  CmsNewsArticle,
  CmsPage,
  CmsSettings,
  CmsText,
} from "./types/cms";

interface Data {
  pages?: CmsPage[];
  events?: CmsEvent[];
  news?: CmsNewsArticle[];
  settings?: CmsSettings[];
}

const data: Data = require("./data.json");

function filterPages(
  pages: CmsPage[],
  eventPageTitle?: string,
  newsPageTitle?: string
) {
  let filteredPages = pages;
  // If event page title is set, but data.events is empty, remove the event page from the menu
  if (eventPageTitle && data.events?.length === 0) {
    filteredPages = filteredPages.filter((p) => p.title !== eventPageTitle);
  }
  // If news page title is set, but data.news is empty, remove the news page from the menu
  if (newsPageTitle && data.news?.length === 0) {
    filteredPages = filteredPages.filter((p) => p.title !== newsPageTitle);
  }
  return filteredPages;
}

function App() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const siteTitle: string | undefined = (data.settings as CmsSettings[])[0]
    ?.title;

  const siteLogo: CmsImage | undefined = (data.settings as CmsSettings[])[0]
    ?.logo;

  const startPageTitle: string | undefined = (data.settings as CmsSettings[])[0]
    ?.startPage;
  let startPage: CmsPage | undefined;

  if (startPageTitle) {
    startPage = data.pages?.find((page) => page.title === startPageTitle);
  }

  const eventPageTitle: string | undefined = (data.settings as CmsSettings[])[0]
    ?.eventsPage;

  const newsPageTitle: string | undefined = (data.settings as CmsSettings[])[0]
    ?.newsPage;

  const footerData: (CmsText | CmsImage)[] = (data.settings as CmsSettings[])[0]
    .footer;

  // const settings = (data.settings as CmsSettings[])[0];
  // const shareUrl = window.location.href;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route
          path="*"
          element={
            <div onClick={(e) => setIsMenuOpen(false)}>
              <Header
                siteTitle={siteTitle}
                siteLogo={siteLogo}
                startPage={startPage}
                pages={filterPages(
                  data.pages || [],
                  eventPageTitle,
                  newsPageTitle
                )}
                isMenuOpen={isMenuOpen}
                setIsMenuOpen={setIsMenuOpen}
              />
              <main
                style={{ backgroundColor: "white" }}
                className="container px-8 mx-auto xl:px-5 max-w-screen-lg py-5 lg:py-8 flex flex-col lg:flex-row"
              >
                <div className="mx-auto bg-background w-full">
                  <Routes>
                    {startPage && (
                      <Route path="/" element={<Page {...startPage} />} />
                    )}
                    {data.pages &&
                      data.pages.map((page) => (
                        <Route
                          key={page.slug}
                          path={`/${page.slug}`}
                          element={
                            <Page title={page.title} body={page.body}>
                              {eventPageTitle &&
                                page.title === eventPageTitle &&
                                data.events && (
                                  <DateItemList
                                    items={data.events}
                                    sortOrder="asc"
                                    hide="past"
                                  />
                                )}
                              {newsPageTitle &&
                                page.title === newsPageTitle &&
                                data.news && (
                                  <DateItemList
                                    items={data.news}
                                    hide="future"
                                  />
                                )}
                            </Page>
                          }
                        />
                      ))}
                    {data.news &&
                      data.news.map((news) => (
                        <Route
                          key={news.slug}
                          path={`/nyheter/${news.slug}`}
                          element={
                            <Page
                              title={news.title}
                              subtitle={news.date}
                              body={news.body}
                            />
                          }
                        />
                      ))}
                    {/* 404 page */}
                    <Route path="*" element={<h1>404</h1>} />
                  </Routes>
                </div>
                {/* <aside
                  className="sidebar"
                  style={{
                    width: "100%",
                    maxWidth: "240px",
                    marginLeft: "auto",
                  }}
                >
                  <div className="sidebar-content pl-4 pr-4">
                    <BorderedHeading large>
                      <h2 className="pt-2 w-full md:w-auto text-3xl font-headline text-light-headline lg:text-4xl justify-right">
                        Dela
                      </h2>
                    </BorderedHeading>
                    <div className="mt-4 flex flex-row gap-1 justify-end">
                      {Object.values(settings.sharing).map((social) => {
                        switch (social) {
                          case "facebook":
                            return (
                              <FacebookShareButton
                                key="facebook"
                                url={shareUrl}
                              >
                                <FacebookIcon size={32} round />
                              </FacebookShareButton>
                            );
                          case "x":
                            return (
                              <TwitterShareButton key="twitter" url={shareUrl}>
                                <XIcon size={32} round />
                              </TwitterShareButton>
                            );
                          case "linkedin":
                            return (
                              <LinkedinShareButton
                                key="linkedin"
                                url={shareUrl}
                              >
                                <LinkedinIcon size={32} round />
                              </LinkedinShareButton>
                            );
                          case "reddit":
                            return (
                              <RedditShareButton key="reddit" url={shareUrl}>
                                <RedditIcon size={32} round></RedditIcon>
                              </RedditShareButton>
                            );
                          case "email":
                            return (
                              <EmailShareButton key="email" url={shareUrl}>
                                <EmailIcon size={32} round></EmailIcon>
                              </EmailShareButton>
                            );
                          default:
                            return null;
                        }
                      })}
                    </div>
                  </div>
                </aside> */}
              </main>
              {footerData && footerData.length > 0 && (
                <Footer items={footerData} />
              )}
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
